// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoCardDetailsRequest {
    static getAttributeTypeMap() {
        return MangoCardDetailsRequest.attributeTypeMap;
    }
}
MangoCardDetailsRequest.discriminator = undefined;
MangoCardDetailsRequest.additionalProperties = false;
MangoCardDetailsRequest.attributeTypeMap = [
    {
        "name": "activationCodes",
        "baseName": "activationCodes",
        "type": ""
    },
];
//# sourceMappingURL=mangoCardDetailsRequest.js.map